<template>
    <div>
        <select class="form-select" v-model="selectedValue">
            <option :value="null">{{ emptyLabel }}</option>
            <option v-for="estateType in estateTypes" :value="estateType">
                {{ capitalizeFirstLetter($t('estateType.' + estateType + '.singular.first_case')) }}
            </option>
        </select>
    </div>
</template>

<script lang="ts">
import {EstateType} from '@/model/api';
import {defineComponent, PropType, ref, watch} from 'vue';

export default defineComponent({
    props: {
        estateTypes: {
            type: Array as PropType<EstateType[]>,
            default: () => [],
        },
        /** Text of the "no type" option; empty by default as the floating map panels have no room for it. */
        emptyLabel: {
            type: String,
            default: '',
        },
    },
    emits: ['change'],
    setup(props, {emit}) {
        const selectedValue = ref<EstateType | null>(null);

        watch(selectedValue, () => {
            emit('change', selectedValue.value);
        });

        function capitalizeFirstLetter(text: string): string {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }

        return {selectedValue, capitalizeFirstLetter};
    },
});
</script>
